import { z } from 'zod'
import { ref } from '@omnea-app/packages/universal/references/refKinds'

// The entity types that can be used for custom fields in request forms
export const RequestFormCustomFieldEntityTypeSchema = z.enum([
  'supplier',
  'purchase-order',
  'supplier-profile',
  'bank-account',
  'user-attribute',
  'agreement-term',
  'category',
  'market',
])
export type RequestFormCustomFieldEntityType = z.infer<typeof RequestFormCustomFieldEntityTypeSchema>

export const RequestFormCustomFieldPropertySchema = z.object({
  // The binding itself: a question carrying this depends on the field, and the entity type beside it
  // narrows nothing, since a custom field id is unique across them.
  id: ref('customField'),
  type: RequestFormCustomFieldEntityTypeSchema,
})
export type RequestFormCustomFieldProperty = z.infer<typeof RequestFormCustomFieldPropertySchema>
